import * as React from "react"
import { WidgetTour } from "../../types"

interface IProps {
  tour: WidgetTour
  onChange: (update: Partial<WidgetTour>) => void
}

const SettingsPanel = ({ tour, onChange }: IProps) => (
  <div className="bizzey-tb-settings">
    <label className="bizzey-tb-settings__row">
      <span>Name</span>
      <input
        className="bizzey-tb-input"
        type="text"
        value={tour.name || ""}
        onChange={(e) => onChange({ name: e.currentTarget.value })}
      />
    </label>

    <label className="bizzey-tb-settings__row">
      <span>Enabled</span>
      <input
        type="checkbox"
        checked={Boolean(tour.enabled)}
        onChange={(e) => onChange({ enabled: e.currentTarget.checked })}
      />
    </label>

    <label className="bizzey-tb-settings__row">
      <span>Accent color</span>
      <input
        type="color"
        value={tour.color || "#1a73e8"}
        onChange={(e) => onChange({ color: e.currentTarget.value })}
      />
    </label>

    <label className="bizzey-tb-settings__row">
      <span>Background color</span>
      <input
        type="color"
        value={tour.background_color || "#ffffff"}
        onChange={(e) => onChange({ background_color: e.currentTarget.value })}
      />
    </label>
  </div>
)

export default SettingsPanel
